import {
  base_colorAction,
  text_colorTextPrimary,
  text_colorTextSecondary,
  text_colorTextSuccess,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_lg,
  font_md,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.TodoListRenderer {
    margin-bottom: ${spacing(4)};

    .title {
      ${font_lg};
      font-family: ${font_family_weight_medium};
      margin-bottom: ${spacing(2)};
    }

    .todo-list {
      display: flex;
      flex-direction: column;
      gap: ${spacing(1)};
    }

    .todo-item {
      display: flex;
      align-items: center;
      gap: ${spacing(2)};

      .icon {
        flex-shrink: 0;
      }

      .content {
        ${font_md};
        color: ${text_colorTextPrimary};
        flex: 1;

        &.completed {
          color: ${text_colorTextSuccess};
          text-decoration: line-through;
        }

        &.in_progress {
          color: ${base_colorAction};
        }

        &.pending {
          color: ${text_colorTextSecondary};
        }
      }
    }

    & .progress-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 1px solid ${text_colorTextSecondary};

      &.completed {
        border-color: ${text_colorTextSuccess};
      }

      &.in_progress {
        border-color: ${base_colorAction};
      }
    }
  }
`
